/**
 * workshopCreateSeriesEditors — the draft edits for the series list: change one
 * generated date by hand, undo it, and the rule for when the schedule above has
 * moved far enough that hand edits no longer line up. Split from
 * useWorkshopCreateForm to keep that file under its size cap.
 */
import type { Dispatch, SetStateAction } from 'react';

import type { ScheduleTextKey, WorkshopDraft } from './useWorkshopCreateForm';
import { withOccurrenceEdit, type SeriesEdit } from './workshopCreateSeries';

/** Changing any of these regenerates the series, so hand edits made against
 *  the old list no longer line up. End time is not one: it only changes each
 *  workshop's length. */
const REGENERATING_KEYS: ReadonlySet<ScheduleTextKey> = new Set([
  'date',
  'start',
  'repeat',
  'endMode',
  'untilDate',
  'occurrenceCount',
]);

export function regeneratesSeries(key: ScheduleTextKey): boolean {
  return REGENERATING_KEYS.has(key);
}

export function makeSeriesEditors(
  setDraft: Dispatch<SetStateAction<WorkshopDraft>>,
  clearError: (key: string) => void,
) {
  const editOccurrence = (index: number, field: keyof SeriesEdit, value: string) => {
    setDraft((d) => ({
      ...d,
      schedule: { ...d.schedule, seriesEdits: withOccurrenceEdit(d.schedule, index, field, value) },
    }));
    clearError('seriesDates');
  };
  const resetOccurrence = (index: number) => {
    setDraft((d) => {
      const seriesEdits = { ...d.schedule.seriesEdits };
      delete seriesEdits[index];
      return { ...d, schedule: { ...d.schedule, seriesEdits } };
    });
    clearError('seriesDates');
  };
  return { editOccurrence, resetOccurrence };
}
